import backend from 'app/backend';
import { dispatch } from 'app/store';
import { User } from 'types/user';
export default function SwitchUser(email: string, currentUser: User) {
  dispatch({
    type: 'SWITCH_USER_START',
  });
  const Email = email.trim();
  return backend
    .dispatch('SwitchUser', {
      Email,
    })
    .then((response) => {
      if (!response.Success) {
        dispatch({
          type: 'SWITCH_USER_FAIL',
          restoreUser: currentUser,
        });
        throw new Error(response.Error);
      }
      dispatch({
        type: 'SWITCH_USER_SUCCESS',
        user: response.Result,
      });
      window.location.reload();
    });
}
